import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1044"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.305 2.801h-2.378V1.687a.697.697 0 1 0-1.394 0v1.114H5.738V1.687a.697.697 0 1 0-1.395 0v1.114H1.699a.698.698 0 0 0-.697.698v10.762c0 .386.312.698.697.698h5.36a.698.698 0 0 0 0-1.396H2.396V6.932h11.211v.658a.697.697 0 1 0 1.394 0V3.5a.697.697 0 0 0-.696-.699zM2.396 5.535V4.198h11.211v1.337H2.396z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M11.675 8.401a3.291 3.291 0 0 0-3.288 3.294c0 1.819 1.472 3.294 3.288 3.294s3.288-1.475 3.288-3.294a3.291 3.291 0 0 0-3.288-3.294zm0 1.397c.252-.006.459.054.589.103l-2.248 2.691a1.74 1.74 0 0 1-.236-.897c.026-.983.975-1.875 1.895-1.897zm0 3.794a1.573 1.573 0 0 1-.589-.103l2.247-2.691c.218.391.24.719.236.897-.025.983-.973 1.875-1.894 1.897z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }